import ArticlePreview from './ArticlePreview'
import PropTypes from 'prop-types'
import YouTube from 'react-youtube'
import styles from '../styles/RelatedContentPanel.module.scss'

const RelatedContentPanel = ({
  articles,
  isLoading,
  relatedVideo,
  showAdvancedFilters,
}) => {
  const count = 1 + (relatedVideo ? 0 : 1) + (showAdvancedFilters ? 0 : 1)
  return (
    <>
      <h5 className='title'>Related Content</h5>
      {isLoading && articles === undefined ? (
        <div className={styles.articlePreviews}>
          <div className={styles.articlePreview}>
            <ArticlePreview isLoading small />
            <ArticlePreview isLoading small />
          </div>
        </div>
      ) : articles || relatedVideo ? (
        <div className={styles.content}>
          {relatedVideo && (
            <div className={styles.videoWrapper}>
              <YouTube videoId={relatedVideo.youtube} />
            </div>
          )}
          <div className={styles.articlePreviews}>
            {articles?.slice(0, count).map((article) => (
              <div className={styles.articlePreview} key={article.href}>
                <ArticlePreview
                  {...article}
                  link={article.href}
                  small
                  title={article.value}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.noData}>No content</div>
      )}
    </>
  )
}

RelatedContentPanel.propTypes = {
  articles: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  relatedVideo: PropTypes.shape({ youtube: PropTypes.string.isRequired }),
  showAdvancedFilters: PropTypes.bool.isRequired,
}

export default RelatedContentPanel
